module.exports = __webpack_public_path__ + "static/media/p508gt.4a08a958.jpg";